module.exports = __webpack_public_path__ + "static/media/Home_Background_Particles2.2d0ec5aa.svg";